import { encode } from 'uqr';

/** QR code drawn as inline SVG from the string itself (11 §1.2: no image service, no CDN; CSP-safe).
 *  Black on white with the 4-module quiet zone scanners expect, whatever the theme: authenticator
 *  apps fail on low-contrast or inverted codes. ECC level M is enough for an otpauth:// URI. */
export function QrCode({
  value,
  size = 200,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) {
  const { data, size: modules } = encode(value, { ecc: 'M', border: 4 });
  let d = '';
  data.forEach((row, y) =>
    row.forEach((on, x) => {
      if (on) d += `M${x} ${y}h1v1h-1z`;
    }),
  );
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${modules} ${modules}`}
      shapeRendering="crispEdges"
      className="rounded-md border border-border"
    >
      <rect width={modules} height={modules} fill="#fff" />
      <path d={d} fill="#000" />
    </svg>
  );
}
